export default __webpack_public_path__ + "static/media/404.3395314b.png";